import { optionSearch_eventsForEmail } from './strings.locstring.json';
import { optionTitle_eventsForEmail } from 'owa-locstrings/lib/strings/optiontitle_eventsforemail.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
/**
 * Txp options settings
 */
let TxpOption: LazyOption = createLazyOption(
    {
        key: 'txp',
        titleStringKey: optionTitle_eventsForEmail,
        searchTermsStringKey: optionSearch_eventsForEmail,
        hideTitleInFullOptions: true,
        allowedOptionKeys: ['EventsFromEmail'],
    },
    lazyFullModule,
    m => m.default
);
export default TxpOption;
